import classNames from "classnames";
import React, { FC } from "react";

interface Props {
    message: string;
    className?: string;
}

export const ErrorMessage: FC<Props> = ({ message, className }) => (
    <div className={classNames("error-message-legacy", className)} dangerouslySetInnerHTML={{ __html: message }} />
);
